import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Admin, AdminState } from '../types';
import { resetAuthState, setAuthData } from './authReducer';

const initialState: AdminState = {
  admin: null,
  loading: false,
  error: null,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    fetchAdminStart(state) {
      state.loading = true;
      state.error = null;
    },

    setAdminData(state, action: PayloadAction<Admin>) {
      setAuthData();
      state.admin = action.payload;
      state.loading = false;
    },

    fetchAdminError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
      resetAuthState();
    },

    resetAdminState: () => initialState,
  },
});

export const { fetchAdminStart, setAdminData, fetchAdminError, resetAdminState } =
  adminSlice.actions;

export default adminSlice.reducer;
